export const featuredListingPromoImage = (story, version = null) => {
  if (!story) return null
  const featured = story.featured_listing
  return (
    featured.promo_image &&
    (version ? featured.promo_image[version] : featured.promo_image)
  )
}

export default featuredListingPromoImage
